
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PackageService = {
  getPackages: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${API_BASE_URL}/admin-api/v3/rate-card-types?rateCardType=package`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      // Transform the response to match the expected format
      const packages = response.data?.data || [];
      return packages.map(pkg => ({
        id: pkg.id,
        name: pkg.name,
        label: pkg.name,
        description: pkg.description,
        rateCardType: pkg.rateCardType,
        createdAt: pkg.createdAt,
        updatedAt: pkg.updatedAt
      }));
    } catch (error) {
      console.error('Error fetching packages:', error);
      throw error;
    }
  },
};

export default PackageService;
